// src/StoreLinks.js
import React from 'react';
import appStoreLogo from '../assets/app-store-logo.png'; // Add your logo images in the assets directory
import playStoreLogo from '../assets/play-store-logo.png';
import windowsStoreLogo from '../assets/windows-store-logo.svg';

const StoreLinks = () => {
  return (
    <div style={{ textAlign: 'center', margin: '30px 0' }}>
      {/* <a href="https://apps.apple.com/us/app/geo-genius-flags-maps-coat/id6497168919" target="_blank" rel="noopener noreferrer">
        <img src={appStoreLogo} alt="App Store" style={{ height:'60px', margin: '15px' }} />
      </a> */}
      <a href="https://play.google.com/store/apps/details?id=com.thedarkhorse.fmm" target="_blank" rel="noopener noreferrer">
        <img src={playStoreLogo} alt="Play Store" style={{ height:'60px',  margin: '15px' }} />
      </a>
      {/* <a href="https://www.microsoft.com/store/apps/9P2PH8MGN52X" target="_blank" rel="noopener noreferrer">
        <img src={windowsStoreLogo} alt="Windows Store" style={{ height:'60px', margin: '15px' }} />
      </a> */}
    </div>
  );
};

export default StoreLinks;
